const initialState = {
  message: null,
  variant: null,
  configs: {},
};

export default initialState;
